// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3td2D","index":"styles_index__20GYi"};